export enum RecipeProgramParameterEnum {
  SPEED = 'SPEED',
  TEMPERATURE = 'TEMPERATURE',
  DURATION = 'DURATION'
}
